import endpoints from './endpoints';
import {throttled, fetch} from '~/lib/fetch';

export default {
  fetch: throttled(async (signal, postalCode, houseNumber, annex) => {
    const result = await fetch(`${endpoints.address}`, {
      signal,
      method: 'POST',
      body: JSON.stringify({
        postalCode,
        houseNumber,
        annex,
      }),
    });

    if (result?.status !== 200) {
      return {
        success: false,
      };
    }

    const json = await result.json();
    return json;
  }),
};
